/* INDIGREY — editorial information pages.
   Elegant accordion for Client Care (FAQ): smooth grid-rows open/close,
   accessible aria state. Independent items (multiple may stay open). */
(function () {
  function toggle(btn) {
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    var panel = btn.nextElementSibling;
    if (panel && panel.classList.contains('ig-rd-faq__panel')) {
      panel.classList.toggle('is-open', !open);
    }
  }

  function init() {
    var btns = document.querySelectorAll('.ig-rd-faq__q');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.dataset.igBound) { continue; }
      btn.dataset.igBound = '1';
      btn.addEventListener('click', function (e) { e.preventDefault(); toggle(this); });
    }
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
